import { setupFormState } from '@/components/form/tidal-form'
import { RECURRENCE_TYPES_PRIORITY } from '@/server-data'

import { TrafficProfileFormValues } from './types'

export const initialValues = {
  recurrence: {
    type: 'any' as uui.domain.rm.RecurrenceTypes,
    source: 'any',
    value: null,
    priority: RECURRENCE_TYPES_PRIORITY['any'],
  },
}

export const form = setupFormState<TrafficProfileFormValues>({
  id: 'trafficProfileForm',
  initialValues,
})
